enum ResourceTypesEnum {
    ADDRESS = "Address",
    ATTACHMENT = "Attachment",
    ATTRIBUTE = "Attribute",
    CATALOG = "Catalog",
    CATALOG_ITEM = "Catalog_Item",
    CATEGORY = "Category",
    CLIENT = "Client",
    CONNECTION_TOKEN = "Connection_Token",
    EXPORT = "Export",
    NUTS_CATALOG_ITEM = "Nuts_Catalog_Item",
    NUTS_ORDER_DETAIL = "Nuts_Order_Detail",
    NUTS_ORDER_ITEM = "Nuts_Order_Item",
    ORDER = "Order",
    ORDER_DETAIL = "Order_Detail",
    ORDER_ITEM = "Order_Item",
    PRICE_GROUP = "Price_Group",
    PROJECT = "Project",
    SHIPMENT = "Shipment",
    SHIPMENT_GROUP = "Shipment_Group",
    SHIPMENT_GROUP_ORDERS_MAP = "Shipment_Group_Orders_Map",
    SHIPMENT_ORDERS_MAP = "Shipment_Orders_Map",
    SUPPLIER = "Supplier",
    VENDOR = "Vendor",
    VENDOR_PRICE_GROUP_MAP = "Vendor_Price_Group_Map",
}

export default ResourceTypesEnum;
